export type CustomUiText = {
  zh: string;
  en: string;
  pt?: string;
};

export function getIsChineseLang(lang: { rawCode?: string; code?: string }): boolean {
  return lang.rawCode?.toLowerCase().startsWith('zh') || lang.code?.toLowerCase().startsWith('zh') || false;
}

export function getCustomUiLanguage(lang: { rawCode?: string; code?: string }): 'zh' | 'en' | 'pt' {
  const rawCode = lang.rawCode?.toLowerCase();
  const code = lang.code?.toLowerCase();
  const resolved = rawCode || code || '';

  if (resolved.startsWith('zh')) {
    return 'zh';
  }

  if (resolved.startsWith('pt')) {
    return 'pt';
  }

  return 'en';
}

export function pickCustomUiText(text: CustomUiText, lang: { rawCode?: string; code?: string }) {
  const language = getCustomUiLanguage(lang);

  if (language === 'zh') {
    return text.zh;
  }

  if (language === 'pt') {
    return text.pt || text.en;
  }

  return text.en;
}
